import { goToNextCell } from '../../../table-utils';
import { TableSpecs } from './TableSpecs';
import { createTableAction, deleteTableAction } from './actions';
import * as TableActions from './actions';
import * as TableHelpers from './helpers';
export { TableHelpers, TableActions };
export { TableNode, TableAttrs, CellAlign as TableCellAlign } from './const';
export const Table = (builder) => {
    builder.use(TableSpecs);
    builder.addKeymap(() => ({
        Tab: goToNextCell('next'),
        'Shift-Tab': goToNextCell('prev'),
    }));
    builder
        .addAction('createTable', createTableAction)
        .addAction('deleteTable', () => deleteTableAction);
};
